var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMathLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 848.5 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-math {\n        fill: #000;\n      }\n\n      .cls-1-math, .cls-2-math {\n        stroke-width: 0px;\n      }\n\n      .cls-2-math {\n        fill: #1976d2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-math",
    d: "M169.5,173.7c-11.9-8-20.8-21.6-20.8-35.9v-29.7c0-25-11.8-35.9-32.3-35.9s-28.1,9-36.1,15.2c-3-6-9.2-15.2-25.1-15.2s-27.1,9-31.7,13.4v-10.6H0v100.8h23.5v-71.7c3.4-4,12.9-11.2,22.1-11.2s16.9,5.2,16.9,18v64.9h23.5v-71.7c4.2-4.8,13.2-11.2,23.3-11.2s15.7,6,15.7,19v31.6h0c0,32.3,23.5,32.3,23.5,32.3h2.9c11.5,0,18.1-2,18-2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M237.3,78.2c-6.8-4.5-14.8-6.8-22.9-6.7-30.3,0-51.6,21.7-51.6,53.4s26.6,51,54.4,51,30.3-4.2,43.2-12.3V29h-23.1v49.2h0ZM209.3,156.8c-8.4,0-17.6-3.5-22.3-8.8v-52.2c6.1-3.6,13.1-5.3,20.1-5.1,16,0,30.1,12.7,30.1,31.9s-10.9,34.2-28,34.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-math",
    d: "M501,30.1c-8,0-14,1.9-18.2,3.9l3.5,8.2c2.6-1,7.3-2.8,13.5-2.8s10.6,2.9,10.6,7.5v5.7c-3.3-3.1-9.2-4.3-14.1-4.3-11.9,0-19,7.4-19,15.8s6.7,17.2,22.5,17.2,17.6-3.1,21.4-6.5v-25.4c0-11.7-4.2-19.2-20.2-19.2h0ZM510.4,69.6c-2.3,1.4-6.4,2.6-10.4,2.6-7.5,0-10.8-3.9-10.8-7.7s3.4-7.5,9.8-7.5,9.4,2.1,11.5,4.1v8.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-math",
    d: "M602.3,30.1c-7.5,0-13,4-15.5,6.3V1.2h-11.3v78.5h11.3v-34.2c1.5-2,6.4-5.6,11.1-5.6,7.8,0,9.4,5,9.4,13.4v26.3h11.3v-32.3c0-12.2-5.8-17.4-16.3-17.4h0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-math",
    d: "M641.8,43.4c0-2.9,2.7-4.9,6.3-4.9s9.5,3.8,10.2,4.7l4.2-7.8c-2.1-1.8-8-5.5-15.8-5.5s-16.9,6.6-16.9,13.9c0,13.4,21.4,14.5,21.4,23.4s-2.8,5.6-7.2,5.6-10.5-3.1-13.4-5.8l-4.2,8.1c3.6,3,10,6.3,18.2,6.3s18.1-6,18.1-14.7c0-14.8-21-15.1-21-23.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-math",
    d: "M468.8,61.6v-14.3c0-12-5.6-17.2-15.5-17.2s-13.5,4.3-17.3,7.3c-1.4-2.9-4.4-7.3-12-7.3s-13,4.3-15.2,6.4v-5.1h-11.3v48.4h11.3v-34.4c1.6-1.9,6.2-5.4,10.6-5.4s8.1,2.5,8.1,8.6v31.1h11.3v-34.4c2-2.3,6.3-5.4,11.2-5.4s7.5,2.9,7.5,9.1v15.1h0c0,15.5,11.3,15.5,11.3,15.5h1.4c5.5,0,8.7-.9,8.6-1-5.7-3.8-10-10.4-10-17.2h0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-math",
    d: "M559,69.1h0c-9.8-1-15.2-6.7-15.9-13v-16h22.9v-10.2h-22.9V0h-12.9v52.5h0c.4,16.5,12.1,27.2,29.6,27.2s5.2-.3,7.8-.8c-3.7-2.5-6.7-5.8-8.6-9.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M471.9,95.9h-.6c-4.2.2-7.5,3.8-7.3,8h0v.3c0,4.4,3.7,7.9,8.1,7.8,4.4,0,7.9-3.7,7.8-8.1v-.8c-.2-4.2-3.8-7.4-8-7.2h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-math",
    x: 465.7,
    y: 121,
    width: 12.4,
    height: 53.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M505.6,129.2v-8.2h-12.4v53.1h12.4v-29.5c0-6.6,3.5-13.3,9.5-13.3s5,.9,7,2.5l4.5-11.6c-2.8-1.8-6.1-2.7-9.5-2.6-6.2,0-10.4,7.2-11.6,9.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M558,119.6c-16.6,0-27.7,12-27.7,28.4s11.8,27.7,29.3,27.7c8,.2,15.9-2.3,22.4-7l-3.9-8.8c-4.7,3.7-10.5,5.6-16.4,5.6-11.7,0-17.9-6.3-18.6-13.1h40.8v-5.1c0-14.7-8.6-27.5-25.8-27.5h0v-.2ZM543.2,142.3c.7-7.5,7.1-13.2,14.6-12.9h.5c7,0,12.7,5.9,12.6,12.9h-27.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M621.7,165.5h-.8c-9.2-.6-16.2-8.5-15.6-17.7,0-11.5,7.9-17.8,16.4-17.8,4.8.1,9.3,1.9,12.8,5.1l4.7-9.3c-5.2-4-11.5-6.2-18.1-6.2-15.3-.2-28,11.9-28.4,27.2-.5,15.5,11.7,28.4,27.2,28.9,7.7.4,15.2-2.4,20.9-7.7l-4-8.6c-4,4.1-9.5,6.3-15.1,6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M715.2,119.6c-15.5-.3-28.3,11.9-28.7,27.4-.3,15.5,11.9,28.3,27.4,28.7h.6c15.5,0,28-12.5,28-28s-12.2-27.8-27.4-28.1h.1ZM729.5,147.7c0,10.8-6.2,17.7-15.7,17.7h-.2c-9.1-.5-16-8.3-15.5-17.4,0-10.9,6.8-18.1,16-18.1s15.3,7.2,15.3,17.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M766.7,129.2v-8.2h-12.4v53.1h12.4v-29.5c0-6.6,3.5-13.3,9.5-13.3s5,.9,7,2.5l4.5-11.6c-2.8-1.8-6.1-2.7-9.5-2.6-6.2,0-10.4,7.2-11.6,9.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-math",
    points: "834.2 121 818.5 154.6 802.9 121 789.1 121 811.5 167.3 792.8 201 806.8 201 848.5 121 834.2 121"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M438.8,121.4c-3.8-2.5-8.2-3.8-12.7-3.7-16.8,0-28.6,12-28.6,29.6s14.8,28.3,30.1,28.3,16.8-2.3,24-6.8v-74.7h-12.8s0,27.3,0,27.3ZM423.3,165c-4.7,0-9.8-1.9-12.4-4.9v-29c3.4-2,7.3-2.9,11.2-2.8,8.9,0,16.7,7.1,16.7,17.7s-6.1,19-15.5,19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M678,165.1h0c-9.8-1-15.2-6.7-15.8-13v-16h19.8v-10.2h-19.8v-29.8h-12.9v52.4h0c.4,16.5,12.1,27.2,29.5,27.2s5.2-.3,7.8-.8c-3.7-2.5-6.6-5.8-8.6-9.8h0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-math",
    x: 325.3,
    y: 27.7,
    width: 7.1,
    height: 146
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M145.7,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M168.3,277.2v-37c3.2-2.3,7.2-3.4,10.9-3.4,7.3,0,14.1,4.6,14.1,13.8s-4.6,13.6-12.7,13.6-6.9-1.7-8.8-3.5v16.6h-3.6ZM171.9,256.7c1.7,2.4,5.1,4.3,8.7,4.3s9-3.9,9-10.4-4-10.6-10.7-10.6-5.7,1.1-7,2.2v14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M222.3,259.8c-1.7,2.4-5.7,4.3-10.8,4.3-7.7,0-13.4-5.5-13.4-13.6s5.2-13.8,13.2-13.8,11.7,6.4,11.7,13v1h-21.3c0,6.4,4.2,10.4,10.5,10.4s7.2-2.1,8.4-3.4l1.7,2.2ZM219.4,247.8c-.4-4.3-3.1-8-8.2-8s-8.6,2.8-9.3,8h17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M251.6,259.7c-2.1,2.7-5.8,4.4-10.5,4.4-7.6,0-13.4-5.8-13.4-13.6s5.8-13.8,13.8-13.8,8.4,2.7,9.1,3.5l-1.9,2.4c-.6-.6-3.3-2.8-7.3-2.8s-10,3.5-10,10.6,4.6,10.5,10.2,10.5,6.6-1.6,8.3-3.3l1.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M259.4,232.2c-1.5,0-2.8-1.2-2.8-2.7s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7ZM257.5,263.4v-26h3.6v26h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M289.5,260.4c-2.4,2.3-6.3,3.7-11.3,3.7-7.6,0-11.1-4.5-11.1-9.4s6.2-8.5,10.7-8.5,6.2.9,8.2,2.9v-3.6c0-3.2-2.5-5.7-7.1-5.7s-6.4,1.2-7.2,1.6l-1.3-2.7c1.8-.9,4.7-1.9,8.6-1.9,8.4,0,10.6,4,10.6,9.8v13.9ZM286,252.2c-1.5-1.4-4-3.1-7.8-3.1s-7.4,1.8-7.4,5.6,3.5,6.4,7.6,6.4,5.9-.9,7.6-2.2v-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M297.4,263.4v-44.3h3.6v44.3h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M311.4,232.2c-1.5,0-2.8-1.2-2.8-2.7s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7ZM309.6,263.4v-26h3.6v26h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M320.7,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M345.4,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M406.6,263.4v-17c0-4.6-2.1-6.4-5.8-6.4s-6.3,2.2-7.6,3.5c.1.8.2,1.6.2,2.4v17.4h-3.6v-17c0-4.7-2.2-6.3-5.9-6.3s-6.2,2.2-7.3,3.4v19.9h-3.6v-26h3.6v2.8c1.4-1.2,4.5-3.5,8.6-3.5s5.9,1.9,7.1,4c1.9-1.7,5.5-4,9.6-4s8.3,2.9,8.3,9.4v17.3h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M438.2,260.4c-2.4,2.3-6.3,3.7-11.3,3.7-7.6,0-11.1-4.5-11.1-9.4s6.2-8.5,10.7-8.5,6.2.9,8.2,2.9v-3.6c0-3.2-2.5-5.7-7.1-5.7s-6.4,1.2-7.2,1.6l-1.4-2.7c1.8-.9,4.7-1.9,8.6-1.9,8.4,0,10.6,4,10.6,9.8v13.9ZM434.7,252.2c-1.5-1.4-4.1-3.1-7.8-3.1s-7.4,1.8-7.4,5.6,3.5,6.4,7.6,6.4,5.9-.9,7.6-2.2v-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M447.7,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M480.6,263.4v-15.3c0-5.6-1.8-8-6.9-8s-6.6,2.2-7.7,3.5v19.9h-3.6v-44.3h3.6v21.1c1.5-1.3,4.4-3.5,8.7-3.5s9.5,3,9.5,9.7v17h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M491.3,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M528.9,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M561.7,237.4h3.6v23.1c-2.6,2.4-6.2,3.6-10.9,3.6s-11-3.3-11-10v-16.7h3.6v15.9c0,5.3,3.1,7.7,7.6,7.7s5.9-1.1,7.2-2.1v-21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M575.2,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M601.6,264.1c-7.8,0-13.9-5.9-13.9-13.7s6.1-13.7,13.9-13.7,13.8,6.2,13.8,13.7-6,13.7-13.8,13.7ZM611.7,250.4c0-6.1-4.6-10.6-10.1-10.6s-10.2,4.5-10.2,10.7,4.9,10.4,10.1,10.4,10.2-4.2,10.2-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M621.8,263.4v-26h3.6v3.7c.3-1.2,2.6-4.4,5.6-4.4s3.8.9,4.4,1.2l-1.7,3.4c-.5-.4-1.6-1.1-3-1.1-3,0-5,3.3-5.2,5.5v17.7h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-math",
    d: "M638.9,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathLogo);
export default __webpack_public_path__ + "static/media/math-logo.3d58b07523097b4f3dfcfb00f17c9340.svg";
export { ForwardRef as ReactComponent };